import { apiClient } from "@/lib/api";

export type AgentTranscriptEndedWith = "user_stop" | "error" | "time_limit";

export type AgentVoiceTranscriptTurn =
  | { role: "user" | "assistant"; text: string }
  | { role: "recommendations"; activity_ids: string[]; activity_names: string[] };

export interface AgentVoiceTranscriptListItem {
  id: string;
  call_id: string;
  language: string;
  duration_ms: number;
  ended_with: AgentTranscriptEndedWith;
  preview_text: string | null;
  turn_count: number;
  created_at: string;
}

export interface AgentVoiceTranscriptDetail {
  id: string;
  call_id: string;
  language: string;
  turns: AgentVoiceTranscriptTurn[];
  duration_ms: number;
  ended_with: AgentTranscriptEndedWith;
  preview_text: string | null;
  created_at: string;
}

export interface AgentVoiceTranscriptListResponse {
  items: AgentVoiceTranscriptListItem[];
  total: number;
}

export function recommendedActivityNamesFromTurns(
  turns: AgentVoiceTranscriptTurn[],
): string[] {
  const names: string[] = [];
  const seen = new Set<string>();
  for (const turn of turns) {
    if (turn.role !== "recommendations") {
      continue;
    }
    for (const name of turn.activity_names) {
      if (seen.has(name)) {
        continue;
      }
      seen.add(name);
      names.push(name);
    }
  }
  return names;
}

export const agentVoiceTranscriptKeys = {
  all: ["admin", "agent-voice-transcripts"] as const,
  list: (skip: number, limit: number) =>
    [...agentVoiceTranscriptKeys.all, "list", skip, limit] as const,
  detail: (id: string) =>
    [...agentVoiceTranscriptKeys.all, "detail", id] as const,
};

export const agentVoiceTranscriptService = {
  async list(params: {
    skip?: number;
    limit?: number;
  }): Promise<AgentVoiceTranscriptListResponse> {
    const { data } = await apiClient.get<AgentVoiceTranscriptListResponse>(
      "/admin/agent-voice-transcripts",
      { params },
    );
    return data;
  },

  async get(id: string): Promise<AgentVoiceTranscriptDetail> {
    const { data } = await apiClient.get<AgentVoiceTranscriptDetail>(
      `/admin/agent-voice-transcripts/${id}`,
    );
    return data;
  },
};
